<template>
  <div>
    <div style="height: 50px;"></div>
    <Bar3d :id="id" :chartData="chartData" :style="{ height: height, width: width }"/>
  </div>
</template>

<script>
  import Bar3d from "@/components/Mycharts/Bar3d.vue";

  export default {
    name: "Zhuyaoyuqinglaiyuan",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      },id: {
        type: String,
        default: "chart"
      },
      width: {
        type: String,
        default: "200px"
      },
      height: {
        type: String,
        default: "300px"
      }
    },
    components: {
      Bar3d
    },
    data() {
      return {};
    },
    mounted() {}
  };
</script>

<style scoped lang="less"></style>
